import React, { useEffect, useState } from 'react';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import MatchCheerCommentInput from './commentInput';
import MatchCheerCommentList from './commentList';
import MatchCheerStore from './store';
import Seo from '../../../../components/seo';
import { ScoreUtil } from '../../../../common/utils/scoreUtil';
import styled from 'styled-components';
import UserAction from './userAction';
import { MypageService } from '../../../../common/services';
import useCommonStore from '../../../../hooks/useCommonStore';
import SuperChatCarousel from './superChatCarousel';
import SuperChatInput from './superChatInput';
import BottomSheet from '../../../../components/bottomSheet';

const IS_VIEW_ALL_CHEER = 'isViewAllCheer';

const MatchCheer = ({
  sportsType,
  sportsId,
  detail,
  toggleSmallView,
  isSmallView,
  isInit = true
}) => {
  const { id } = useParams();
  const [viewChatInput, setViewChatInput] = useState(false);
  const [viewChat, setViewChat] = useState(false);
  const [viewUserAction, setViewUserAction] = useState(false);
  const [selectedUser, setSelectedUser] = useState({ user: {} });
  const [blackList, setBlackList] = useState([]);
  const [viewBottomSheet, setViewBottomSheet] = useState(false);
  const [bottomSheetPhrases, setBottomSheetPhrases] = useState('');
  const [bottomSheetTimeout, setBottomSheetTimeout] = useState(null);

  const {
    getCheerList,
    getCheerMore,
    postCheerComment,
    postCheerCommentReport,
    getCheerCommentReport,
    closeSocket,
    closeChampSocket,
    data,
    setRef,
    changeCurrentSlide,
    isAll,
    changeViewMode,
    deletePowerChat
  } = MatchCheerStore();
  const commonStore = useCommonStore();
  const { getTeamData, cheerCount } = detail;
  const teams = useMemo(() => {
    if (!!getTeamData) {
      return getTeamData;
    } else {
      return {
        home: { id: 0, imgPath: '' },
        away: { id: 0, imgPath: '' }
      };
    }
  }, [getTeamData]);

  const getBlackList = async () => {
    await MypageService.blackList(1, 1000).then((res) => {
      if (res.code === 200) {
        const blackIdList = [];
        res.data.list.map((item) => blackIdList.push(item.mb_id));
        setBlackList(blackIdList);
      }
    });
  };

  useEffect(() => {
    if (commonStore.loginCheck) {
      getBlackList().then((r) => getCheerList(id, sportsType, sportsId, 1));
    } else {
      getCheerList(id, sportsType, sportsId, 1);
    }

    return () => {
      closeSocket();
      closeChampSocket();
    };
  }, []);

  useEffect(() => {
    const handleStorage = (event) => {
      if (event.key === IS_VIEW_ALL_CHEER) {
        changeViewMode(event.newValue === 'true');
      }
    };
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  const onClickAll = () => {
    if (isAll) {
      setBottomSheetPhrases('응원하기 모두보기가 비활성화 됩니다.');
    } else {
      setBottomSheetPhrases('응원하기 모두보기가 활성화 됩니다.');
    }
    changeViewMode(!isAll);
    bottomSheetToggle();
  };

  const bottomSheetToggle = () => {
    setViewBottomSheet(true);
    if (bottomSheetTimeout === null) {
      setBottomSheetTimeout(bottomSheetHideTimeout());
    } else {
      clearTimeout(bottomSheetTimeout);
      setBottomSheetTimeout(bottomSheetHideTimeout());
    }
  };

  const bottomSheetHideTimeout = () => {
    return setTimeout(() => {
      setViewBottomSheet(false);
      setBottomSheetTimeout(null);
    }, 2000);
  };

  const viewSuperChatCarousel =
    data.powerChat.comments.length > 0 &&
    (detail.gameStatus === 'READY' || detail.gameStatus === 'IN_PROGRESS');

  return (
    <div className="cheer_area">
      <Seo title={`스포츠 ${ScoreUtil.getSportName(sportsType)} 상세 응원`} />
      <BottomSheet phrases={bottomSheetPhrases} view={viewBottomSheet} />
      {viewSuperChatCarousel && (
        <SuperChatCarousel
          powerChat={data.powerChat}
          viewChat={viewChat}
          setViewChat={setViewChat}
          changeCurrentSlide={changeCurrentSlide}
          bottomSheetToggle={bottomSheetToggle}
          setBottomSheetPhrases={setBottomSheetPhrases}
          deletePowerChat={deletePowerChat}
        />
      )}
      <MatchCheerCommentList
        comments={data.comments}
        loading={data.loading}
        teams={teams}
        getCheerMore={getCheerMore}
        setRef={setRef}
        isSmallView={isSmallView}
        isInit={isInit}
        setViewUserAction={setViewUserAction}
        setSelectedUser={setSelectedUser}
        blackList={blackList}
        cheerCount={cheerCount}
        viewSuperChatCarousel={viewSuperChatCarousel}
        viewChat={viewChat}
      />
      <MatchCheerCommentInput
        postCheerComment={postCheerComment}
        teams={teams}
        toggleSmallView={toggleSmallView}
        setViewChatInput={setViewChatInput}
      />
      <SuperChatInput
        postCheerComment={postCheerComment}
        viewChatInput={viewChatInput}
        setViewChatInput={setViewChatInput}
      />
      <UserAction
        view={viewUserAction}
        onClickClose={() => setViewUserAction(false)}
        selectedUser={selectedUser}
        getBlackList={getBlackList}
        postCheerComment={postCheerComment}
        postCheerCommentReport={postCheerCommentReport}
        getCheerCommentReport={getCheerCommentReport}
        report={data.report}
      />
      <Button className={'all'} active={isAll} onClick={onClickAll} />
    </div>
  );
};

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 50px;
  height: 50px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.3);
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.6);
  :before {
    content: '';
    width: 100%;
    height: 100%;
    display: block;
  }
  &.all {
    right: 20px;
    bottom: 70px;
    :before {
      background: url(${(props) =>
          props.active
            ? '/images/ic-cheer-all-off.svg'
            : '/images/ic-cheer-all.svg'})
        no-repeat center center;
      background-size: 22px 15px;
    }
  }
  &.vs {
    :before {
      background: url('/images/ic-vs.svg') no-repeat center center;
      background-size: 22px 39px;
    }
  }
`;

export default MatchCheer;
